/* eslint-disable */
export class Keuzehulp {
  constructor() {
    // bind events
    $(document).on('click', '.question_item.answer', e => this.anchorScroll(e));
  }

  /**
   * Show linked element and scroll to it
   * @param e
   */
  anchorScroll(e) {
    e.preventDefault();
    const clickedElement = $(e.target);
    clickedElement.siblings('.question_item').removeClass('link_active');
    clickedElement.closest('.question_wrapper').nextAll('.question_wrapper').find('.link_active').removeClass('link_active');
    clickedElement.addClass('link_active');
    clickedElement.closest('.question_wrapper').nextAll('.question_wrapper').hide();

    const subItemId = clickedElement.attr('data-child-id')
    this.subItemsLoad(subItemId);

    const target = e.target.getAttribute('href');
    this.waitForElement(target, 300, 20, () => {
      const targetElement = $(target);
      targetElement.css('display', '');
      const windowHeight = $(window).height();
      const elementHeight = targetElement.outerHeight();
      const elementOffset = targetElement.offset().top;
      const scrollTo = elementOffset - (windowHeight / 2) + (elementHeight / 2);

      $('html, body').animate({ scrollTop: scrollTo }, 500);
    });

  }

  /**
   * Pre-load subitems
   * @param {number} postId
   */
  subItemsLoad(postId){
    $.ajax({
      url: ajax_link,
      method: 'POST',
      data: {
        action: 'load_keuzehulp',
        post_id: postId,
      },
      success: function(response) {
        const container = $('.keuzehulp .container');
        container.append(response);
      }
    });
  }

  /**
   * Wait until the element appears in the DOM
   * @param {string} selector
   * @param {number} interval
   * @param {number} attempts
   * @param {function} callback
   */
  waitForElement(selector, interval, attempts, callback) {
    let tries = 0;
    const check = () => {
      const targetElement = $(selector);
      if (targetElement.length > 0) {
        callback();
      } else if (tries < attempts) {
        tries++;
        setTimeout(check, interval);
      } else {
        console.warn(`Element ${selector} was not found after ${attempts} tries.`);
      }
    };
    check();
  }

}
